export default {
    select_button: 'Velg',
    one_day_back: 'En dag tilbake',
    one_day_forward: 'En dag frem',
    departure: 'Avgang',
    arrival: 'Ankomst',
    duration: 'Reisetid',
    transfers: 'Bytter',
    status: 'Status',
    price: 'Pris',
    select: 'Velg en avgang',
    read_and_agree: 'Lest og akseptert',
    status_cancelled: 'Bestillingstidspunktet for denne avgangen er passert, kontakt båten om det fortsatt er ledig plass og ankomst.',
    status_time_passed: 'Bestillingstidspunktet for denne avgangen er passert. Billetter kan kjøpes ombord dersom ledig plass. Kontakt',
    by_phone: 'på telefon',
    status_no_capacity: 'Det er ikke ledig plass på ønsket strekning. Forsøk med mindre antall reisende/kjøretøy eller velg en annen avgang.',
    status_available: 'Det er ledig plass på ønsket strekning på søketidspunktet, og du kan kjøpe/reservere billett til denne avgangen ved å velge den.',
    //status_on_board: 'Bestillingstidspunktet for denne avgangen er passert. Det var fortsatt ledig plass, kontakt båten om det fortsatt er ledig plass og ankomst.',
    norwegian_krone: 'kr',
    no_result: 'Det er ingen flere avganger i dag, eller det er ingen avganger på valgt dato.'
}
